import { Component, OnInit } from '@angular/core';
import { Confrontation } from '../../../../shared';

@Component({
  selector: 'app-test-cases',
  templateUrl: './test-cases.component.html',
  styleUrls: ['./test-cases.component.css']
})
export class TestCasesComponent implements OnInit {

  leftText: string;
  // for routes
  config = Confrontation;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/test-cases/components/test-cases/test-cases.component.ts